import React from 'react';
import styles from '../css/style.css';
import logo from "../img/logo/logo1.png"
import max from "../img/logo/max16x16.png"
import {NavLink} from "react-router-dom";
import {
    ABOUT_ROUTE,
    CATALOG_ROUTE, CATEGORY_BLOCK_HOUSE,
    CATEGORY_EDGED_BOARD, CATEGORY_EVRO_VAGONKA, CATEGORY_FLOOR_BOARD, CATEGORY_IMITATION_TIMBER,
    CATEGORY_PLANED_BLOCK,
    CATEGORY_PLANED_BOARD, CATEGORY_SHTIL, CONTACT,
    INDEX_ROUTE, PRIVACY_POLICY
} from "../utils/consts";
import {RiTelegram2Line} from "react-icons/ri";

const Footer = () => {
    return (
        <footer className="footer_widgets">
            <div className="footer_top">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-2 col-md-4 col-sm-6">
                            <div className="widgets_container contact_us">
                                <h3>Связаться с нами</h3>
                                <p><i className="icon-watch"></i><span>Пн - Пт:</span> 09:00 – 19:00</p>
                                <p><i className="icon-phone"></i><span>Тел1:</span> 8(916)737-55-95</p>
                                <p><i className="icon-phone"></i><span>Тел2:</span> 8(495)222-32-95</p>
                                <p><RiTelegram2Line /><span>Telegram:</span><a className="link-footer" href="https://t.me/holc_city" target="_blank"> holc_city</a></p>
                                <p><img src={max} alt="MAX" /><span> MAX:</span>8(916)737-55-95</p>
                                <p><i className="icon-mail"></i><span>Электронная почта:</span> 89852223295@mail.ru</p>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-3 col-sm-6">
                            <div className="widgets_container widget_menu">
                                <h3>Информация</h3>
                                <div className="footer_menu">
                                    <ul>
                                        <li><NavLink to={ABOUT_ROUTE}>О нас</NavLink></li>
                                        <li><NavLink to={CONTACT}>Контакты</NavLink></li>
                                        <li><NavLink to={CATEGORY_PLANED_BOARD}>Каталог</NavLink></li>
                                        <li><NavLink to={PRIVACY_POLICY}>Политика конфиденциальности</NavLink></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-5">
                            <div className="widgets_container widget_app">
                                <div className="footer_logo">
                                    <NavLink to={INDEX_ROUTE}><img src={logo} alt="" /></NavLink>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6">
                            <div className="widgets_container widget_menu">
                                <h3>Каталог</h3>
                                <div className="footer_menu">
                                    <ul>
                                        <li><NavLink to={CATEGORY_PLANED_BOARD}>Доска строганная</NavLink></li>
                                        <li><NavLink to={CATEGORY_PLANED_BLOCK}>Брусок строганный</NavLink></li>
                                        <li><NavLink to={CATEGORY_EDGED_BOARD}>Доска обрезная</NavLink></li>
                                        <li><NavLink to={CATEGORY_BLOCK_HOUSE}>Блок-Хаус</NavLink></li>
                                        <li><NavLink to={CATEGORY_IMITATION_TIMBER}>Имитация бруса</NavLink></li>
                                        <li><NavLink to={CATEGORY_SHTIL}>Штиль</NavLink></li>
                                        <li><NavLink to={CATEGORY_FLOOR_BOARD}>Доска пола</NavLink></li>
                                        <li><NavLink to={CATEGORY_EVRO_VAGONKA}>Евровагонка</NavLink></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer_bottom">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">
                            <div className="copyright_area">
                                <p className="copyright-text">&copy; <NavLink to={INDEX_ROUTE}>Holz-City</NavLink></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;